module.exports = __webpack_public_path__ + "img/0-lg.5ca9b841.jpg";